import React from 'react';

import { useI18n } from 'Hooks';

import Button from '../Button';
import { ButtonStyleType } from '../Button';
import Modal from '../Modal';
import { Buttons, Text } from './styles';
import ModalContentWrapper from '../Modal/ModalContentWrapper';

export interface Props {
  question: string;
  isShowing: boolean;
  onLeftClick: () => void;
  onRightClick?: () => void;
  leftText?: string;
  rightText?: string;
  leftStyle?: ButtonStyleType;
  rightStyle?: ButtonStyleType;
  width?: string;
  icon?: any;
}

const QuestionModal: React.FunctionComponent<Props> = ({
  question,
  isShowing,
  onLeftClick,
  onRightClick,
  leftText,
  rightText,
  leftStyle = 'Dark',
  rightStyle = 'Dark',
  width = '560px',
  icon,
}) => {
  const { t } = useI18n();

  return (
    <Modal isShowing={isShowing} backdropClose={false}>
      <ModalContentWrapper width={width}>
        {icon && icon}
        <Text>{question}</Text>
        <Buttons>
          <Button
            text={leftText ?? t('General.Yes')}
            handleClick={onLeftClick}
            styleType={leftStyle}
          />
          {onRightClick && (
            <Button
              text={rightText ?? t('General.No')}
              handleClick={onRightClick}
              styleType={rightStyle}
            />
          )}
        </Buttons>
      </ModalContentWrapper>
    </Modal>
  );
};

export default QuestionModal;
